<template>
  <form id="search-header"
        name="search-header"
        @submit.prevent="showOverlay">
    <label class="search-header-wrap"
           for="search-dummy"
           @click="showOverlay">
      <span v-for="term in terms"
            @mouseup.prevent="remove(term)"
            class="term">{{ term }} </span>
      <input v-if="terms.length === 0" name="search-dummy"
             id="search-dummy"
             type="text"
             placeholder="Wonach suchen Sie?"
             class="form-control js-indexed-search-header-form-sword float-left"
             autocomplete="off"
             @focus="showOverlay"/>
    </label>
  </form>
</template>

<script>
import SearchObject from "./SearchObject";

export default {
  name: 'SearchHeader',
  data() {
    return {
      searchObj: new SearchObject()
    }
  },
  components: {},
  methods: {
    showOverlay(evt) {
      if (evt.target.tagName === 'LABEL' ||
          evt.target.tagName === 'INPUT') {
        let _d = document;
        _d.getElementById('search-overlay').classList.add('visible');
        _d.getElementById('search-needle').focus();
      }
    },
    remove(term) {
      let tmp = this.terms;

      // if the last term will be removed reset also the region and type
      if (tmp.length === 1) {
        this.searchObj.resetRegion();
        this.searchObj.resetType();
      }
      this.searchObj.Needle = tmp.filter(function (el) {
        return el != term;
      }).join(' ');

      setTimeout(function () {
        document.getElementById('vue-search').submit();
        document.getElementById('search-progress').classList.add('d-table');
      }, 200);
    }
  },
  computed: {
    terms() {
      // handle terms only on results page where the submitted searchObject
      // will be injected through SearchObjectMiddleWare
      if (typeof window.searchObj !== 'object') {
        return [];
      }
      return this.searchObj.Needle
          .split(' ')
          .filter(function (el) {
            return el != '';
          });
    }
  }
}
</script>

<style lang="scss">
</style>